import { z } from "zod";

// Worker-safe: Define TagColors enum inline to avoid importing from React component
// This is a duplicate of TagColors from @certa/catalyst/components/Tag
// Keep in sync with the source if colors are added/removed
export enum TagColors {
  NEUTRAL = "Neutral",
  TEAL = "Teal",
  RED = "Red",
  DARK_RED = "DarkRed",
  GREEN = "Green",
  PURPLE = "Purple",
  ORANGE = "Orange",
  BLUEBERRY = "Blueberry",
  BRICK = "Brick",
  BLUE = "Blue",
  PINK = "Pink",
  GREY = "Grey",
  // eslint-disable-next-line @typescript-eslint/naming-convention
  Brand = "Brand"
}

const BadgeUiTypeEnum = z.enum(["info", "warning", "error", "success"]);

export type BadgeUIType = z.infer<typeof BadgeUiTypeEnum>;

const BadgeUIModeEnum = z.enum(["icon", "label", "both"]);

export type BadgeUIMode = z.infer<typeof BadgeUIModeEnum>; // default is both

export const BadgeUISpecsSchema = z.object({
  type: BadgeUiTypeEnum.optional(),
  mode: BadgeUIModeEnum.optional(),
  color: z.nativeEnum(TagColors).optional(),
  icon: z.string().optional()
});

export type BadgeUISpecs = z.infer<typeof BadgeUISpecsSchema>;

export type Badge = {
  fieldTag: string | null;
  name: string;
  helpText: string;
  tag: string;
  uiSpecs?: BadgeUISpecs;
};

export type BadgeRaw = {
  field_tag: string | null;
  name: string;
  help_text: string;
  tag: string;
  ui_specs: BadgeUISpecs;
};

export type AppliedBadge = {
  createdAt: string;
  tag: string;
};

export type AppliedBadgeRaw = {
  created_at: string;
  tag: string;
};
